<router-outlet></router-outlet>

<div
  [innerHTML]="skeleton$ | async"
  [@slideInOut]="animationState$ | async"></div>
